import React, { Component} from 'react'
export default class Footer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <footer className="m-grid__item m-footer bg-dark p-0 d-flex align-items-center">
                <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
                    <div className="m-footer__wrapper bg-transparent shadow-none">
                        <div className="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                            <div className="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                                <span className="m-footer__copyright float-right text-white">
                                    © {new Date().getFullYear()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            )
    }
}